import { escapeHtml, isValidSearchTerm } from '../utils/testable-utils';

export function initForms() {
  document.querySelectorAll('[data-contact-form]').forEach((form) => {
    form.addEventListener('submit', (event) => {
      event.preventDefault();

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      const formData = new FormData(form);
      const product = escapeHtml(formData.get('product') || 'Producto de ZNZI Store');
      const response = form.querySelector('[data-form-response]');

      if (response) {
        response.hidden = false;
        response.textContent = `Solicitud preparada para ${product}. Continúa en Discord para finalizar la compra.`;
      }
    });
  });

  document.querySelectorAll('[data-site-search]').forEach((form) => {
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const input = form.querySelector('input[type="search"]');
      const value = input?.value.trim() || '';

      if (!isValidSearchTerm(value)) {
        input?.setAttribute('aria-invalid', 'true');
        return;
      }

      input.removeAttribute('aria-invalid');
      const terms = [
        ['scanner', '/scanner'],
        ['anticheat', '/anticheat'],
        ['servicios', '/servicios'],
        ['tienda', '/store'],
        ['store', '/store'],
        ['top players', '/top-players'],
        ['ranking', '/top-players'],
        ['jugadores', '/top-players'],
        ['discord', '/discord'],
      ];
      const destination = terms.find(([term]) => value.toLowerCase().includes(term));
      window.location.assign(destination ? destination[1] : '/');
    });
  });
}
